import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import EventBatchFields from './EventBatchFields'

export const EventBatchCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <EventBatchFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default EventBatchCreate
